import { useState } from "react";
import { remissionPDFByUuidEvent } from "../../../_events/remission/find_remission.event";
import { message } from "antd";

export const useModalPdf = () => {
    
    const [ bytes, setBytes ] = useState(null);
    const [ open, setOpen ] = useState(false);
    const [ loading, setLoading ] = useState(false);

    const hanldeClose = () => {
        setOpen(false);
        setBytes(null);
    }

    const downloadPdf = (uuid) => {
        setOpen(true);
        remissionPDFByUuidEvent(uuid)
        .then(json => {
            setBytes(json.data.bytes);
        })
        .catch(err => {
            message.error(err.message);
        });
    }
    
    return {
        bytes, loading, downloadPdf, open, hanldeClose
    };
}